import { get } from 'lodash';
import { CompanyApplicantRelatedPartyType, TrustApplicantRelatedPartyType } from '@lendi/core-constants';

import { FIELD_PATHS } from '@funnels/constants';
import { FormValues, RelatedParty, StoreApplicant } from '@funnels/types';

interface RelatedPartyIdMap {
  trustApplicantClientIds: string[];
  companyApplicantClientIds: string[];
}

const getRelatedNonPersonApplicants = (formValues: Partial<FormValues>, applicantIndex: number) => {
  let relatedTrustApplicants = [],
    relatedCompanyApplicants = [];

  const applicantClientId = get(formValues, FIELD_PATHS.APPLICANT_CLIENT_ID(applicantIndex));

  const relatedParties: RelatedParty[] = get(formValues, FIELD_PATHS.RELATED_PARTIES(), []);

  const { trustApplicantClientIds, companyApplicantClientIds } = relatedParties.reduce(
    (result: RelatedPartyIdMap, _, index) => {
      const relatedPartyType = get(formValues, FIELD_PATHS.RELATED_PARTY_TYPE(index));
      const isRelated = get(formValues, FIELD_PATHS.RELATED_PARTY_APPLICANT_CLIENT_ID(index)) === applicantClientId;

      if (relatedPartyType === TrustApplicantRelatedPartyType.Trustee && isRelated) {
        result.trustApplicantClientIds.push(
          get(formValues, FIELD_PATHS.RELATED_PARTY_TRUST_APPLICANT_CLIENT_ID(index))
        );
      } else if (relatedPartyType === CompanyApplicantRelatedPartyType.Director && isRelated) {
        result.companyApplicantClientIds.push(
          get(formValues, FIELD_PATHS.RELATED_PARTY_COMPANY_APPLICANT_CLIENT_ID(index))
        );
      }
      return result;
    },
    { trustApplicantClientIds: [], companyApplicantClientIds: [] }
  );

  const applicants: StoreApplicant[] = get(formValues, FIELD_PATHS.APPLICANTS(), []);

  relatedTrustApplicants = applicants.filter((_, index) =>
    trustApplicantClientIds.includes(get(formValues, FIELD_PATHS.APPLICANT_CLIENT_ID(index)))
  );

  relatedCompanyApplicants = applicants.filter((_, index) =>
    companyApplicantClientIds.includes(get(formValues, FIELD_PATHS.APPLICANT_CLIENT_ID(index)))
  );

  return { relatedTrustApplicants, relatedCompanyApplicants };
};

export default getRelatedNonPersonApplicants;
